import { ElementType } from "react";
import { Box, useTheme } from "@mui/material";
import Layout from "@/pages/layout";
import ServiceStatus from "@/components/admin/ServiceStatus";
import { Grid } from "@mui/system";
import { AdminHeader } from "@/components/admin";
import { AdminProvider } from "@my-helpers/common";

const Admin: ElementType = () => {
    const theme = useTheme();

    return (
        <Layout>
            <AdminProvider>
                <Box padding={theme.spacing(3)}>
                    <AdminHeader />
                    <Grid container>
                        <Grid size={6}>
                            <ServiceStatus />
                        </Grid>
                    </Grid>
                </Box>
            </AdminProvider>
        </Layout>
    );
};

export default Admin;
